module.exports = __webpack_public_path__ + "img/Profil_CS-Lite_Standard.c779e79c.jpg";